import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivationStart,
  NavigationCancel,
  NavigationEnd,
  NavigationStart,
  Params,
  QueryParamsHandling,
  Router,
} from '@angular/router';
import { ChannelContextService } from '@x/ecommerce-shop/app/channel/services/channel-context.service';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RoutingContextService {
  routeTransition$: Observable<boolean> = this.router.events.pipe(
    filter(
      (event) =>
        event instanceof ActivationStart ||
        event instanceof NavigationStart ||
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel,
    ),
    map((event) => event instanceof NavigationStart || event instanceof ActivationStart),
  );

  routeTransitionEnd$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd || event instanceof NavigationCancel),
    map((event) => Boolean(event)),
  );

  get redirectUrl(): string {
    const { redirect } = this.queryParams;
    const channelCode = this.channelContext.channelCode;

    if (redirect) return `${redirect}`;

    if (channelCode) return `/${channelCode}`;

    return '/';
  }

  get queryParams(): Params {
    return this.route.snapshot.queryParams;
  }

  goHome(paramsHandling?: QueryParamsHandling) {
    const channelCode = this.channelContext.channelCode;
    const url = channelCode ? `/${channelCode}` : '/';

    this.router.navigate([`/${url}`], {
      ...(paramsHandling && { queryParamsHandling: 'preserve' }),
    });
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private channelContext: ChannelContextService,
  ) {}
}
